import styled from 'styled-components';

export const ItemDialogReasonDivider = styled.div`
  width: 16px;
`;
